import React from 'react'
import {useHistory} from 'react-router-dom'

import telephoneIcon from "../../../../assets/telephone-icon.svg";
import rocketIcon from "../../../../assets/rocketIcon.svg";
import locationIcon from "../../../../assets/locationIcon.svg";
import triangles1 from "../../../../assets/VO_ServicesTriangles_1.png";
import triangles2 from "../../../../assets/VO_ServicesTriangles_2.png";
import serviceDelivery from "../../../../assets/services_man_with_packages.png";
import macbookImage from "../../../../assets/macbook-image.png";
import darkbluePolygon from "../../../../assets/darkblue_polygon.png";

import "./ServiceFeatures.scss";
import Button from "../../../../components/button/Button";
import BulletPoint from "../../../../components/bulletPoint/BulletPoint";

const ServiceFeatures = () => {
    const history = useHistory()
    const list1 = [
        'Local and International Phone Numbers available',
        'Customized Call Handling',
        'Call Patch / Transfer Features',
        'Voicemail To Email',
        'All messages logged and sent via email',
        'Customized Greeting',
        'General FAQ provided to callers',
        'Online Access To Your Account',
    ]

    const list2 = [
        'Call Routing',
        'Automatic Call Distribution',
        'Call Screening',
        'Voice Mail',
        'Zero-out to Operator or Attendant',
    ]

    const list3 = [
        'Remote Extensions',
        'Auto vAttendant',
        'Directory Assistance Listing',
        'Extension Dialing, Local Number Porting (LNP)',
        'Music on Hold',
        '3-Way Calling',
        'Voicemail to Email',
        'Voicemail',
    ]
    return (
        <div id="answering-services" className="ServiceFeatures">
            <section className="ServiceFeatures__Wrapper">
                <div className="ServiceFeatures__Wrapper__Container page__padding">
                    <div className="left">
                        <div className="icon">
                            <img src={telephoneIcon} alt=""/>
                        </div>
                        <div className="primary__heading heading">Answering Services</div>
                        <div className="paragraph">
                            Keep your business running with professional, 24/7 business
                            phone
                            answering. 85% Of People Whose Calls Aren’t Answered Will Not
                            Call
                            Back. Never Miss An Enquiry. Win More Business Opportunities
                            with
                            our award-winning Live Telephone Answering Services.
                        </div>
                        <div className="list">
                            <ul>
                                {list1.map((item, index) => {
                                    return <BulletPoint key={index} type="regular"
                                                        item={item}/>;
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className="right">
                        <img className="triangle1" src={triangles1} alt=""/>
                    </div>
                </div>
            </section>
            <section className="ServiceFeatures__Wrapper midSection">
                <div className="ServiceFeatures__Wrapper__Container">
                    <div className="right">
                        <img className="orangeTriangle" src={triangles2} alt=""/>
                    </div>
                    <div className="left">
                        <div className="icon">
                            <img src={rocketIcon} alt=""/>
                        </div>
                        <div className="primary__heading heading">Automated Attendant
                        </div>
                        <div className="paragraph">
                            Now there's no need to purchase an expensive Auto Attendant or
                            PBX
                            to answer your calls and route them to the correct person or
                            department. Your new Auto Attendant and phone system can be
                            hosted
                            by Virtual Enterprise. It will answer your phone calls with
                            your
                            company's menu and transfer callers to the correct person or
                            department.
                        </div>
                        <div className="list">
                            <ul>
                                {list2.map((item, index) => {
                                    return <BulletPoint key={index} type="regular"
                                                        item={item}/>;
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <section className="ServiceFeatures__Wrapper ServiceFeatures__Blue">
                <div id="corporate-address"
                     className="ServiceFeatures__Wrapper__Container page__padding">
                    <div className="left">
                        <div className="icon">
                            <img src={locationIcon} alt=""/>
                        </div>
                        <div className="primary__heading heading">
                            Corporate Address Features
                        </div>
                        <div className="paragraph">
                            Win over potential customers with your business mailing
                            address.
                            We'll take care of the mail and make sure it's forwarded or
                            held
                            according to your instructions.
                            <br/>
                            <br/>
                            Whether you're expanding into new markets and need a new place
                            to
                            work or just need someone to answer your phone and handle your
                            mail, Virtual Enterprise is for you. Virtual Enterprise
                            provides a
                            place to post Real Estate and other professional documents. It
                            also can be the business address for your corporation,
                            allowing
                            you to separate your business address from your personal
                            address.
                        </div>
                    </div>
                    <div className="right">
                        <img className="serviceDelivery" src={serviceDelivery} alt=""/>
                    </div>
                </div>
            </section>
            <section className="ServiceFeatures__Wrapper">
                <div className="ServiceFeatures__Wrapper__Container page__padding">
                    <div className="left">
                        <div className="ctaBox">
                            <div className="primary__heading ctaText">
                                Grow your business today.
                            </div>
                            <Button
                                onclick={() => history.push('/price-plan')}
                                text="Plans & Pricing"
                                type="primary"
                            />
                        </div>
                    </div>
                </div>
            </section>
            <section className="ServiceFeatures__Wrapper ServiceFeatures__DarkBlue">
                <div id="collaborate-assistant"
                     className="ServiceFeatures__Wrapper__Container">
                    <div className="right">
                        <img src={macbookImage} alt=""/>
                        <img className="darkbluePolygon" src={darkbluePolygon} alt=""/>
                    </div>
                    <div className="left">
                        {/* <div className="icon">
              <img src={rocketIcon} alt="" />
            </div> */}
                        <div className="primary__heading heading">
                            Collaborate in an instant.
                        </div>
                        <div className="paragraph">
                            A flexible cloud based phone system breaks down barriers by
                            moving
                            the on-premise PBX phone system out of the building and into
                            the
                            cloud. Workers in the office and remote workers alike share
                            the
                            same features and capabilities of a powerful business phone
                            system
                            regardless of their physical locations. When employees leave
                            their
                            remote offices, a mobile or desktop application allows them to
                            remain connected to the corporate phone system.
                        </div>
                        <div className="list">
                            <strong>Features Include:</strong>
                            <ul>
                                {list3.map((item, index) => {
                                    return <BulletPoint key={index} type="inverse"
                                                        item={item}/>;
                                })}
                            </ul>
                        </div>
                        <Button onclick={() => history.push('/contact')}
                                classStyle={"contact_sales"} text={"Contact Sales"}
                                type={"primary"}/>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default ServiceFeatures
